/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SavedCommodity,
  ShopifyCommoditySyncResult,
  ShopifyCommoditySyncStatus,
} from '../models/index';
import {
    SavedCommodityFromJSON,
    SavedCommodityToJSON,
    ShopifyCommoditySyncResultFromJSON,
    ShopifyCommoditySyncResultToJSON,
    ShopifyCommoditySyncStatusFromJSON,
    ShopifyCommoditySyncStatusToJSON,
} from '../models/index';

export interface AddSavedCommodityRequest {
    savedCommodity?: Omit<SavedCommodity, 'createdSource'|'createdByName'>;
}

export interface DeleteSavedCommodityRequest {
    savedCommodityId: string;
}

export interface ModifySavedCommodityRequest {
    savedCommodity?: Omit<SavedCommodity, 'createdSource'|'createdByName'>;
}

/**
 * 
 */
export class SavedCommoditiesApi extends runtime.BaseAPI {

    /**
     * 
     */
    async addSavedCommodityRaw(requestParameters: AddSavedCommodityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-commodities/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SavedCommodityToJSON(requestParameters['savedCommodity']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async addSavedCommodity(requestParameters: AddSavedCommodityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addSavedCommodityRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async deleteSavedCommodityRaw(requestParameters: DeleteSavedCommodityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['savedCommodityId'] == null) {
            throw new runtime.RequiredError(
                'savedCommodityId',
                'Required parameter "savedCommodityId" was null or undefined when calling deleteSavedCommodity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['savedCommodityId'] != null) {
            queryParameters['savedCommodityId'] = requestParameters['savedCommodityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-commodities/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async deleteSavedCommodity(requestParameters: DeleteSavedCommodityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSavedCommodityRaw(requestParameters, initOverrides);
    }

    /**
     * Your GET endpoint
     */
    async getAllSavedCommoditiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SavedCommodity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-commodities/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SavedCommodityFromJSON));
    }

    /**
     * Your GET endpoint
     */
    async getAllSavedCommodities(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SavedCommodity>> {
        const response = await this.getAllSavedCommoditiesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Whether this company has a connected (linked + enabled) Shopify store, used to decide whether to offer the \"Sync from Shopify\" action.
     * Your GET endpoint
     */
    async getShopifyCommoditySyncStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopifyCommoditySyncStatus>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-commodities/shopify-sync-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopifyCommoditySyncStatusFromJSON(jsonValue));
    }

    /**
     * Whether this company has a connected (linked + enabled) Shopify store, used to decide whether to offer the \"Sync from Shopify\" action.
     * Your GET endpoint
     */
    async getShopifyCommoditySyncStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopifyCommoditySyncStatus> {
        const response = await this.getShopifyCommoditySyncStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async modifySavedCommodityRaw(requestParameters: ModifySavedCommodityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-commodities/modify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SavedCommodityToJSON(requestParameters['savedCommodity']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async modifySavedCommodity(requestParameters: ModifySavedCommodityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.modifySavedCommodityRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a stub Saved Commodity for each Shopify product SKU that doesn\'t have one yet (identity + description; the merchant still supplies dimensions). Existing commodities are left untouched. No-op if the company has no linked Shopify store.
     * 
     */
    async syncSavedCommoditiesFromShopifyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopifyCommoditySyncResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-commodities/sync-shopify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopifyCommoditySyncResultFromJSON(jsonValue));
    }

    /**
     * Creates a stub Saved Commodity for each Shopify product SKU that doesn\'t have one yet (identity + description; the merchant still supplies dimensions). Existing commodities are left untouched. No-op if the company has no linked Shopify store.
     * 
     */
    async syncSavedCommoditiesFromShopify(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopifyCommoditySyncResult> {
        const response = await this.syncSavedCommoditiesFromShopifyRaw(initOverrides);
        return await response.value();
    }

}
